import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./template.vue";
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'; //HalfCircleSpinner 

@Component({
  mixins: [Template],
  components: {
    FulfillingBouncingCircleSpinner
  }
})
export default class Loading extends Vue {
  @Prop({ required: true }) loading!: boolean;
}
